import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Placement, Props } from './placement';
import {
    RESULT_LIST_SPACE_1,
    RESULT_LIST_SPACE_2,
    RESULT_LIST_SPACE_3,
    bannerName,
} from '../utils/result';

let bannerWrappers: HTMLElement[] = [];

function renderPlacement(
    id: string,
    props: Props,
    container: HTMLElement,
    position: number,
) {
    const element = document.createElement('div');
    element.id = `${id}-wrapper`;
    element.setAttribute('style', 'display: flex');
    element.classList.add('u-mb32');
    container.insertBefore(element, container.children[position]);

    bannerWrappers.push(element);
    render(
        <Placement {...props} id={id} className="inline-container" />,
        element,
    );
}

function removeOldBanners() {
    bannerWrappers.forEach((banner) => {
        unmountComponentAtNode(banner);
    });
    bannerWrappers = [];
}
function addNewBanners(containerId: string, props: Props) {
    if (document) {
        const container = document.getElementById(containerId);
        if (container) {
            const length = container.children.length;

            if (length > RESULT_LIST_SPACE_1) {
                renderPlacement(
                    bannerName(props.deviceType, 1),
                    props,
                    container,
                    RESULT_LIST_SPACE_1,
                );
            }
            if (length > RESULT_LIST_SPACE_2) {
                renderPlacement(
                    bannerName(props.deviceType, 2),
                    props,
                    container,
                    RESULT_LIST_SPACE_2,
                );
            }
            if (length > RESULT_LIST_SPACE_3) {
                renderPlacement(
                    bannerName(props.deviceType, 3),
                    props,
                    container,
                    RESULT_LIST_SPACE_3,
                );
            }
        }
    }
}

export function renderSearchResultBanners(
    containerId: string,
    props: Props,
    delay?: number,
) {
    removeOldBanners();
    if (delay) {
        setTimeout(() => {
            addNewBanners(containerId, props);
        }, 500);
    } else {
        addNewBanners(containerId, props);
    }
}
